import { TERMINAL_SUMMARIES } from './thoughtActivityStatus'
import { workStatusSummary } from './workStatusThoughts'

export function timelineFinishedSummary({
  publicView,
  workStatus,
  runId,
  view,
  hasArtifacts,
  thoughtSummary,
  streaming,
}) {
  let summary =
    publicView.phases.at(-1)?.title ??
    workStatusSummary(workStatus, runId) ??
    view.running?.label ??
    null
  if (streaming) return summary
  const terminal = String(thoughtSummary ?? '').trim()
  return (
    summary ??
    (TERMINAL_SUMMARIES.has(terminal) ? terminal : null) ??
    (hasArtifacts ? 'Document ready' : 'Response ready')
  )
}
